import NoNameLogo from "../../assets/images/brand-logo.svg?react";
import NamedLogo from "../../assets/images/logo-name.svg?react";

interface BrandLogoProps {
  expand?: boolean;
}

const BrandLogo = ({
  expand = false,
}: BrandLogoProps) => {
  return (
    <div className="h-6 w-28">
      {expand ? <NamedLogo fill="#191818" /> : <NoNameLogo fill="#191818" /> }
    </div>
  );
};

export default BrandLogo;
